class MockGeolocation {
  constructor(positions) {
    this.positions = positions;
    this.index = 0;
  }

  getCurrentPosition(successCallback, errorCallback, options) {
    successCallback(this.positions[this.index % (this.positions.length - 1)]);
    this.index++;
  }

  watchPosition(successCallback, errorCallback, options) {
    let intervalId = setInterval(() => {
      successCallback(this.positions[this.index % (this.positions.length - 1)]);
      this.index++;
    }, 2000);
    successCallback(this.positions[this.index % (this.positions.length - 1)]);
    return intervalId;
  }

  clearWatch(watchId) {
    clearInterval(watchId);
  }
}

export function useMockGeolocation() {
  let mockGeolocation = new MockGeolocation([
    {
      coords: { latitude: 40.7128, longitude: -74.006, altitude: 0, speed: 3.23, heading: 30, altitudeAccuracy: 3.45 },
    },
    {
      coords: {
        latitude: 40.7129,
        longitude: -74.0061,
        altitude: 10,
        speed: 3.53,
        heading: 35,
        altitudeAccuracy: 5.15,
        accuracy: 5,
      },
    },
    {
      coords: { latitude: 40.713, longitude: -74.0062, altitude: 20, speed: 3.83, heading: 40, altitudeAccuracy: 6.85 },
    },
    {
      coords: {
        latitude: 40.7131,
        longitude: -74.0063,
        altitude: 30,
        speed: 4.13,
        heading: 45,
        altitudeAccuracy: 8.55,
      },
    },
    {
      coords: {
        latitude: 40.7132,
        longitude: -74.0064,
        altitude: 40,
        speed: 4.43,
        heading: 50,
        altitudeAccuracy: 10.25,
      },
    },
    {
      coords: {
        latitude: 40.7133,
        longitude: -74.0065,
        altitude: 50,
        speed: 4.73,
        heading: 55,
        altitudeAccuracy: 11.95,
      },
    },
    {
      coords: {
        latitude: 40.7134,
        longitude: -74.0066,
        altitude: 60,
        speed: 5.03,
        heading: 60,
        altitudeAccuracy: 13.65,
      },
    },
    {
      coords: {
        latitude: 40.7135,
        longitude: -74.0067,
        altitude: 70,
        speed: 5.33,
        heading: 65,
        altitudeAccuracy: 15.35,
      },
    },
    {
      coords: {
        latitude: 40.7136,
        longitude: -74.0068,
        altitude: 80,
        speed: 5.63,
        heading: 70,
        altitudeAccuracy: 17.05,
      },
    },
    {
      coords: {
        latitude: 40.7137,
        longitude: -74.0069,
        altitude: 50,
        speed: 5.93,
        heading: 75,
        altitudeAccuracy: 18.75,
      },
    },
    {
      coords: {
        latitude: 40.7138,
        longitude: -74.007,
        altitude: 1000,
        speed: 6.23,
        heading: 80,
        altitudeAccuracy: 20.45,
      },
    },
    {
      coords: {
        latitude: 40.714,
        longitude: -74.007,
        altitude: 900,
        speed: 6.53,
        heading: 85,
        altitudeAccuracy: 3.12,
      },
    },
    {
      coords: {
        latitude: 40.714,
        longitude: -74.0072,
        altitude: 2286,
        speed: 6.83,
        heading: 90,
        altitudeAccuracy: 23.85,
      },
    },
    {
      coords: {
        latitude: 40.714,
        longitude: -74.0072,
        altitude: 4200,
        speed: 6.83,
        heading: 90,
        altitudeAccuracy: 23.85,
      },
    },
    {
      coords: {
        latitude: 40.714,
        longitude: -74.0072,
        altitude: 4200,
        speed: 6.83,
        heading: 90,
        altitudeAccuracy: 23.85,
      },
    },
  ]);
  // Override the navigator.geolocation object with the mock one if its not already
  if (navigator.geolocation.__proto__.constructor.name !== "MockGeolocation") {
    navigator.geolocation.__proto__ = mockGeolocation;
  }
}
